import { render, staticRenderFns } from "./CompleteWorksCard.vue?vue&type=template&id=086b3eb7&scoped=true&"
import script from "./CompleteWorksCard.vue?vue&type=script&lang=js&"
export * from "./CompleteWorksCard.vue?vue&type=script&lang=js&"
import style0 from "./CompleteWorksCard.vue?vue&type=style&index=0&id=086b3eb7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "086b3eb7",
  null
  
)

export default component.exports
import {QCardSection,QList,QItem,QItemSection,QRadio,QCheckbox,QItemLabel,QInnerLoading,QSpinnerGears,QSeparator,QCardActions,QBtn,QSpace,Ripple} from 'quasar'
component.options.components = Object.assign({QCardSection,QList,QItem,QItemSection,QRadio,QCheckbox,QItemLabel,QInnerLoading,QSpinnerGears,QSeparator,QCardActions,QBtn,QSpace}, component.options.components || {})
component.options.directives = Object.assign({Ripple}, component.options.directives || {})
